import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
  useCallback,
} from 'react';
import PropTypes from 'prop-types';
import ResizeObserver from 'resize-observer-polyfill';

const ContainerDimensionContext = createContext(null);

const ContainerDimensionProvider = ({ children }) => {
  const [dimensions, setDimensions] = useState([0, 0]);
  const containerRef = useRef(null);

  const onResize = useCallback((entries) => {
    entries.forEach((entry) => {
      setDimensions([entry.contentRect.width, entry.contentRect.height]);
    });
  }, []);

  useEffect(() => {
    const resizeObserver = new ResizeObserver(onResize);
    resizeObserver.observe(containerRef.current);
    return () => resizeObserver.disconnect();
  }, []);

  return (
    <ContainerDimensionContext.Provider value={dimensions}>
      {/* background: inherit keeps the client background (inherited at #kouto-embed-root)
          flowing through this measuring wrapper so descendants that opt into
          background: inherit — e.g. the ScheduleView sticky bars — stay opaque. */}
      <div ref={containerRef} style={{ background: 'inherit' }}>
        {children}
      </div>
    </ContainerDimensionContext.Provider>
  );
};

ContainerDimensionProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ContainerDimensionProvider;

export const useContainerDimension = () =>
  useContext(ContainerDimensionContext);

export const useIsNarrowView = () => {
  const [width] = useContainerDimension();
  return width <= 1080;
};
